import React from 'react';
import { UploadedPhoto } from '../prop-types';

const urlRegexp = new RegExp(/[^/]+?(?=\?)|[^/]+$/, 'g');

export default function PhotoFilename({ photo: { filename } }) {
  if (!filename) return null;

  const [output] = filename.match(urlRegexp);

  return <p className="list-item__photos-filename text-truncate">{output}</p>;
}

PhotoFilename.propTypes = {
  photo: UploadedPhoto.isRequired,
};
